import { paths } from '@/configs/paths'
import { convertToRouteObject } from '@/lib/router-utils'
import { PublicRoute } from '@/middleware/PublicRoute'
import { QueryClient } from '@tanstack/react-query'
import { type RouteObject } from 'react-router-dom'

export const createPublicRoutes = (queryClient: QueryClient): RouteObject[] => {
  const convert = convertToRouteObject(queryClient)

  return [
    {
      element: <PublicRoute />,
      children: [
        {
          path: paths.login.path,
          lazy: () => import('@/pages/auth/Login').then(convert)
        },
        {
          path: paths.forgotPassword.path,
          lazy: () => import('@/pages/auth/ForgotPassword').then(convert)
        },
        {
          path: paths.changePassword.path,
          lazy: () => import('@/pages/auth/ChangePassword').then(convert)
        }
      ]
    },
    {
      path: '*',
      lazy: () => import('@/pages/NotFound').then(convert)
    }
  ]
}
